import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { Skeleton } from '@/components/ui/FeedBack/Skeleton';
import { SmallTag } from '@/components/ui/Tag/SmallTag';
/**
 * 日付やタイトルなどの情報をリストの項目のコンポーネント
 * @param props
 * @returns
 */
export const InfoListItemSkeleton = (props) => {
    const { className = '' } = props;
    return (_jsx("li", Object.assign({ className: clsx('group', className) }, { children: _jsxs("div", Object.assign({ className: clsx('py-16 px-8 xs:px-20', 'flex flex-col gap-y-16') }, { children: [_jsxs("div", Object.assign({ className: 'inline-flex items-center justify-start gap-x-16' }, { children: [_jsx(Skeleton, { className: clsx('w-[75px] h-[22px]') }), _jsx(SmallTag, Object.assign({ color: 'info' }, { children: _jsx(Skeleton, { className: clsx('w-[40px] h-[8px]') }) }))] })), _jsx("div", { children: _jsx(Skeleton, { className: clsx('w-full h-[22px]') }) })] })) })));
};
